(function() {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('KarcherServiceController', KarcherServiceController);

  /** @ngInject */
  function KarcherServiceController($stateParams, karcherServiceList, karcherOpenCloseHours, getDaysService) {
    var vm = this;

    var facility = $stateParams.facility;

    vm.serviceList = karcherServiceList.serviceList(facility.facility);
    vm.operationList = karcherServiceList.operationList(facility.facility);
    vm.pumpTypeList = karcherServiceList.pumpTypeList(facility.facility);
    vm.programList = karcherServiceList.programList(facility);
    vm.currentList = karcherServiceList.currentList(facility.facility);

    //Create working hour table
    vm.dayList = getDaysService.getShortDayList();

    vm.lightsOn = karcherOpenCloseHours.lightsOn(facility.facility);
    vm.lightsOff = karcherOpenCloseHours.lightsOff(facility.facility);
    vm.washBoxesOn = karcherOpenCloseHours.washBoxOn(facility.facility);
    vm.washBoxesOff = karcherOpenCloseHours.washBoxOff(facility.facility);
    vm.vacuumsOn = karcherOpenCloseHours.vacuumOn(facility.facility);
    vm.vacuumsOff = karcherOpenCloseHours.vacuumOff(facility.facility);
    vm.workingHoursTable = true;

  }
})();
